
// Helper functions to prefetch components on hover
// optimizing navigation speed without external libraries like @loadable/component

export const prefetchNosotros = () => import('./pages/About');
export const prefetchServicios = () => import('./pages/Services');
export const prefetchPortafolio = () => import('./pages/Portfolio');
export const prefetchBlog = () => import('./pages/Blog');
export const prefetchContacto = () => import('./pages/Contact');

